export default __webpack_public_path__ + "static/media/light.34231afa.woff2";